import PropTypes from 'prop-types';

export const memberTierRuleType = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  condition_interval: PropTypes.shape({
    type: PropTypes.string,
    time_value: PropTypes.string,
    time_unit: PropTypes.string,
  }),
  effect_interval: PropTypes.shape({
    type: PropTypes.string,
    time_value: PropTypes.string,
    time_unit: PropTypes.string,
  }),
  effect_type: PropTypes.string,
  total_spending: PropTypes.shape({
    cents: PropTypes.number,
    currency_symbol: PropTypes.string,
    currency_iso: PropTypes.string,
    label: PropTypes.string,
    dollars: PropTypes.number,
  }),
});

export const merchantMembershipTierType = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  level: PropTypes.number,
  name_translations: PropTypes.shape({
    'zh-hant': PropTypes.string,
    'zh-cn': PropTypes.string,
    en: PropTypes.string,
  }),
  merchant_id: PropTypes.string.isRequired,
  member_count: PropTypes.number,
  exclusive_product_count: PropTypes.number,
  promotion_count: PropTypes.number,
  member_discount_percentage: PropTypes.number,
  valid_period: PropTypes.shape({
    type: PropTypes.string,
    time_value: PropTypes.string,
    time_unit: PropTypes.string,
  }),
  membership_tier_rules: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      condition_interval: PropTypes.shape({
        type: PropTypes.string,
        time_value: PropTypes.string,
        time_unit: PropTypes.string,
      }),
      effect_interval: PropTypes.shape({
        type: PropTypes.string,
        time_value: PropTypes.string,
        time_unit: PropTypes.string,
      }),
      effect_type: PropTypes.string,
      total_spending: PropTypes.shape({
        cents: PropTypes.number,
        currency_symbol: PropTypes.string,
        currency_iso: PropTypes.string,
        label: PropTypes.string,
        dollars: PropTypes.number,
      }),
    }),
  ),
});

export const messagesType = PropTypes.arrayOf(
  PropTypes.shape({
    message: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
);
